/** @type {import('@sveltejs/kit').ParamMatcher} */
export function match(param) {
  return /^(.+)-from-(.+)-(vaccinated|unvaccinated)$/.test(param)
}
